import { createFileRoute } from '@tanstack/react-router';

import { WorkerJobsPage } from '@/features/talent/jobs-pages';

export const Route = createFileRoute('/_app/me/work/jobs')({ component: WorkerJobsPage });
